import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { AuthContext } from "stores/auth";
import CommonProvider from "stores/common";

import ClientRoutes from "./ClientRoutes";
import AdminRoutes from "./AdminRoutes";

const ProtectedRoutes = observer(() => {
  const authStore = useContext(AuthContext);

  let user = authStore.user;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (authStore.selectedAccount) {
      setLoading(false);
    } else if (authStore.hasSelectedAccount) {
      setLoading(true);
      authStore
        .fetchSelectedAccount()
        .then(() => {
          if (isMounted) setLoading(false);
        })
        .catch(() => {
          if (isMounted) setLoading(false);
        });
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [authStore.hasSelectedAccount, authStore.selectedAccount]);

  if (!user) {
    return null;
  }

  return (
    <CommonProvider>
      <div className="h-full container__wrap">
        {user.role === "client" ? (
          <ClientRoutes loading={loading} />
        ) : (
          <AdminRoutes />
        )}
      </div>
    </CommonProvider>
  );
});

export default ProtectedRoutes;
